'use strict';

angular.module('openDataApp')
  .controller('LoginFormCtrl', ['$scope', '$q', '$timeout', 'ApiService', 'AuthService', function ($scope, $q, $timeout, ApiService, AuthService) {

    $scope.login = function (credentials) {
      $scope.submitting = true;
      $scope.loginFormSubmitError = null;

      var def = $q.defer();

      def.resolve();

      $timeout(function () {
        ApiService.login(credentials)
          .then(
            function success(response) {
              $scope.submitting = false;
              AuthService.login(response.data.response);
              def.resolve();
            },
            function error(response) {
              $scope.submitting = false;
              if (response.status === 401) {
                $scope.loginFormSubmitError = 'Computer says no.';
              } else {
                $scope.loginFormSubmitError = 'Er is iets misgegaan, dat ligt aan ons. We zijn ermee aan de slag, probeer het later nog eens.';
              }
              def.reject();
            }
          );
      }, 500); // Small timeout to show progress*/

      return def.promise;
    };

    $scope.logout = function () {
      AuthService.logout();
    };

    $scope.toResetRequest = function () {
      $scope.$parent.$parent.$parent.resetRequest = true; // TODO: Lelluk
    };
  }]);
